import React from 'react';
import { useSelectedStudent } from '../hooks/useSelectedStudent';
import { StudentSelector } from './StudentSelector';

interface StudentDropdownProps {
  className?: string;
  /** Optional `data-tour` id for onboarding (set on wrapper when visible). */
  dataTour?: string;
}

export function StudentDropdown({ className = '', dataTour }: StudentDropdownProps) {
  const { selectedStudentId, selectedStudentName, students, setSelectedStudent } = useSelectedStudent();

  // Don't show dropdown if no student is selected or students haven't loaded yet
  if (!selectedStudentId || !selectedStudentName) {
    return null;
  }

  return (
    <div data-tour={dataTour}>
      <StudentSelector
        students={students}
        selectedStudentId={selectedStudentId}
        onSelect={setSelectedStudent}
        className={className}
        dropdownClassName="right-0 w-48"
        showLabel={false}
      />
    </div>
  );
}
